// Регулярное выражение для площади: положительное число (целое или дробное) больше 0, не более 10000
export const areaRegex = /^(?:0\.\d*[1-9]\d*|(?:[1-9]\d{0,3}(?:\.\d+)?|10000))$/;
// Регулярное выражение для целых неотрицательных чисел (0 или положительное целое) – для большинства полей
export const integerRegex = /^(?:0|[1-9]\d*)$/;
// Для количества комнат: число от 1 до 100
export const roomsRegex = /^(?:[1-9]\d?|100)$/;
// Для этажа: целое число от -100 до 100 (разрешаются отрицательные)
export const floorRegex = /^(?:0|-?(?:[1-9]\d?|100))$/;
